import windows from "./windows"
import logger from "./logger"

const fns: (() => void)[] = []

function invoke(fn: () => void) {
  try {
    fn()
  } catch (e) {
    logger.warn("Error in domReady callback", e)
  }
}

function callback() {
  fns.forEach(invoke)
  fns.length = 0
}

export function domReady(fn: () => void) {
  const { document } = windows.site
  if (document.readyState === "loading") {
    if (fns.length === 0) {
      document.addEventListener("DOMContentLoaded", callback)
    }
    fns.push(fn)
  } else {
    fn()
  }
}
